import React, { useContext } from 'react';

import BillingContext from '@totem/components/ticketing/billing/billingContext';
import Hours from '@totem/components/ui_components/widgets/hours/hours';
import { isNotNull } from '@totem/utilities/common';

const UnbilledSelectedCounts = () => {
  const { selectedUnbilled } = useContext(BillingContext);

  const sumHours = () => {
    let hours = 0;

    selectedUnbilled.forEach((chk) => (hours += chk.timeEntry.hoursLogged));

    return hours;
  };

  return (
    <div>
      {isNotNull(selectedUnbilled) && selectedUnbilled.length > 0 && (
        <>
          <b>Selected Count: {selectedUnbilled.length}</b> -{' '}
          <b>
            Hours Selected: <Hours amount={sumHours()} />
          </b>
        </>
      )}
    </div>
  );
};

export default UnbilledSelectedCounts;
